export default __webpack_public_path__ + "static/product-unit-18-art-32bdc7a1059f997eb668822c119b7d39.png";